import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import DesktopLayout from '../components/layout/DesktopLayout';
import AdCardList from '../components/advertising/AdCardList';
import { getFeaturedAds } from '../services/adsApi';
import type { Ad } from '../types';
import './HomePage.css';

/**
 * 首頁
 * 顯示精選廣告和主要功能入口
 */
const HomePage = () => {
  const navigate = useNavigate();
  const [featuredAds, setFeaturedAds] = useState<Ad[]>([]);
  const [loading, setLoading] = useState(true);

  // 取得精選廣告
  useEffect(() => {
    const fetchFeaturedAds = async () => {
      setLoading(true);
      try {
        const ads = await getFeaturedAds(12, 1); // 取得精選等級1的廣告，最多12個作為緩衝
        const desktopFeaturedAds = (ads as Ad[]).slice(0, 6);
        setFeaturedAds(desktopFeaturedAds);
      } catch (error) {
        console.error('Failed to fetch featured ads:', error);
        setFeaturedAds([]);
      } finally {
        setLoading(false);
      }
    };

    fetchFeaturedAds();
  }, []);

  const handleAdClick = (adId: string) => {
    navigate(`/ads/${adId}`);
  };

  return (
    <div className="home-page">
      <DesktopLayout>
        <div className="home-page__container">
          {/* Hero Section */}
          <section className="home-page__hero">
            <div className="home-page__hero-content">
              <h1 className="home-page__hero-title">溫柔小姊姊｜選物 x 微批發</h1>
              <p className="home-page__hero-subtitle">
                精選好物，點綴您的日常美好時光
              </p>
              <div className="home-page__hero-actions">
                <button
                  className="btn btn--primary btn--large"
                  onClick={() => navigate('/ads')}
                >
                  瀏覽廣告
                </button>
                <button
                  className="btn btn--secondary btn--large"
                  onClick={() => navigate('/wishes')}
                >
                  發布需求
                </button>
              </div>
            </div>
          </section>

          {/* Features Section */}
          <section className="home-page__features">
            <div className="feature-card" onClick={() => navigate('/ads')}>
              <div className="feature-card__icon">🔍</div>
              <h3 className="feature-card__title">瀏覽廣告</h3>
              <p className="feature-card__description">
                依地區和服務項目快速找到您需要的車業服務
              </p>
            </div>

            <div className="feature-card" onClick={() => navigate('/wishes')}>
              <div className="feature-card__icon">💡</div>
              <h3 className="feature-card__title">發布需求</h3>
              <p className="feature-card__description">
                找不到合適的服務？在許願池發布需求，讓服務商主動聯繫您
              </p>
            </div>

            <div className="feature-card" onClick={() => navigate('/member')}>
              <div className="feature-card__icon">📊</div>
              <h3 className="feature-card__title">會員中心</h3>
              <p className="feature-card__description">
                管理您的廣告、查看統計資料、設定通知偏好
              </p>
            </div>
          </section>

          {/* Featured Ads Section */}
          {(!loading || featuredAds.length > 0) && (
            <section className="home-page__featured">
              <h2 className="home-page__section-title">精選廣告</h2>
              <AdCardList ads={featuredAds} loading={loading} onAdClick={handleAdClick} />
              <div className="home-page__view-all">
                <button
                  className="btn btn--secondary"
                  onClick={() => navigate('/ads')}
                >
                  查看所有廣告
                </button>
              </div>
            </section>
          )}
        </div>

        <footer className="home-page__footer">
          <div className="home-page__footer-decoration"></div>
          <div className="home-page__footer-content">
            <div className="home-page__footer-section">
              <h4>關於 小姊姊的生活配方｜選物 x 微批發</h4>
              <p>精選好物，點綴您的日常美好時光</p>
            </div>
            <div className="home-page__footer-section">
              <h4>服務項目</h4>
              <ul>
                <li>選物、微批發</li>
              </ul>
            </div>
            <div className="home-page__footer-section">
              <h4>聯絡我們</h4>
              <p>Email: info@belle-selection.shop</p>
              <p>電話: 0800-123-456</p>
            </div>
          </div>
        </footer>
      </DesktopLayout>
    </div>
  );
};

export default HomePage;
